import { CheckCircle2 } from "lucide-react";
import { Reveal } from "./Reveal";

const POINTS = [
    "grasz z dziećmi na lekcjach i chcesz, żeby zabawa realizowała cele lekcji,",
    "szukasz gier, które angażują myślenie, a nie tylko rozładowują energię,",
    "chcesz grać bez chaosu i utraty kontroli nad grupą,",
    "nie chcesz kupować drogich gier ani spędzać godzin na przygotowaniach.",
];

export default function Audience() {
    return (
        <section className="py-10 sm:py-16 px-4 sm:px-8" data-testid="audience-section">
            <div className="max-w-7xl mx-auto rounded-[2.5rem] bg-brand-ink text-white px-6 sm:px-12 py-14 sm:py-20 relative overflow-hidden">
                <div
                    aria-hidden="true"
                    className="absolute -right-24 -top-24 w-80 h-80 rounded-full bg-brand/30 blur-3xl"
                />
                <div
                    aria-hidden="true"
                    className="absolute -left-16 -bottom-24 w-72 h-72 rounded-full bg-brand/25 blur-3xl"
                />
                <div className="relative grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                    <div>
                        <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight leading-[1.12]">
                            Dla kogo jest ten webinar?
                        </h2>
                        <p className="mt-5 text-base sm:text-lg leading-relaxed text-white/75">
                            Gra na lekcji może być mądrym doświadczeniem dydaktycznym, a nie tylko
                            przerywnikiem na rozładowanie energii. Ten webinar jest dla Ciebie, jeśli:
                        </p>
                        <img
                            src="/assets/kids-circle.webp"
                            loading="lazy"
                            alt="Dzieci w kole, uśmiechnięte, podczas wspólnej zabawy"
                            className="mt-8 w-full h-52 sm:h-64 object-cover rounded-3xl border border-white/15"
                            data-testid="audience-classroom-image"
                        />
                    </div>
                    <ul className="space-y-4">
                        {POINTS.map((p, i) => (
                            <Reveal key={p} delay={i * 0.08}>
                                <li
                                    data-testid={`audience-point-${i + 1}`}
                                    className="flex items-start gap-4 rounded-2xl bg-white/[0.06] border border-white/10 px-5 py-4 backdrop-blur-sm transition-colors duration-300 hover:bg-white/[0.1]"
                                >
                                    <CheckCircle2 className="w-6 h-6 mt-0.5 shrink-0 text-brand-tint2" aria-hidden="true" />
                                    <span className="text-base sm:text-lg font-medium leading-relaxed">{p}</span>
                                </li>
                            </Reveal>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
